import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ExclusionModal from "./CommonComponent/ExclusionModal";
import ExclusionTable from "./CommonComponent/ExclusionTable";
import { Add, Download } from "@mui/icons-material";
import DownloadModal from "./CommonComponent/DownloadModal";

function Exclusion() {
	const [open, setOpen] = useState(false);
	const [downloadOpen, setDownloadOpen] = useState(false);

	return (
		<Box p={2}>
			{/* Header row with title (left) and button (right) */}
			<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
				<Typography variant="h6" fontWeight="bold" mb={3}>
					Exclusion Data
				</Typography>
				<Box display="flex" justifyContent="space-between" alignItems="center" columnGap={3}>
					<Button variant="contained" onClick={() => setDownloadOpen(true)} startIcon={<Download />}>
						Download
					</Button>
					<Button variant="contained" onClick={() => setOpen(true)} startIcon={<Add />}>
						Create
					</Button>
				</Box>
			</Box>

			{/* Table inside Paper for styling */}
			{/* <Paper elevation={3} sx={{ p: 2 }}> */}
			<ExclusionTable />
			{/* </Paper> */}

			{/* Modal */}
			<ExclusionModal open={open} onClose={() => setOpen(false)} />
			<DownloadModal open={downloadOpen} onClose={() => setDownloadOpen(false)} />
		</Box>
	);
}

export default Exclusion;
